import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuidComponent } from './entities/guid/guid.component';
import { PageDownloadComponent } from './entities/page-download/page-download.component';
import { LoginLayoutComponent } from './Layout/template/login-layout.component';
import { HomeLayoutComponent } from './Layout/template/home-layout.component';

import { LoginComponent } from './entities/login/login.component';
import { ItemChangePasswordComponent } from './entities/change-password/item.component';
import { ItemForgotPasswordComponent } from './entities/forgot-password/item.component';
import { InvoiceListComponent } from './entities/invoices/invoice-list/invoice-list.component';
import { InvoiceCheckComponent } from './entities/invoiceCheck/invoice-check.component';
import { ItemEditComponent } from './entities/client-management/item-edit.component';
import { VideoTutorialComponent } from './entities/video-tutorial/video-tutorial.component';

import { AnnouncementRoute, AnnouncementResolvePagingParams } from './entities/announcement/Announcement.route';
import { clientManagementRoute } from './entities/client-management/item.route';
import { DialogNotificationPopupComponent } from './shared/components/dialog-notification/dialog-notification.component';

import { ItemPreviewAnnouncementPopupComponent } from './entities/announcement/Announcement-preview/Announcement-preview.component';
import { UserRouteAccessCrudService } from './shared';
import { ItemPreviewPopupComponent } from './entities/invoice-html/item-preview-dialog.component';

const PTLAYOUT_ROUTES: Routes = [

	{
		path: '',
		component: HomeLayoutComponent,
		// canActivate: [AuthGuard],
		children: [
			{
				path: '',
				component: InvoiceListComponent
			},
			{
				path: 'Guid',
				component: GuidComponent
			},
			{
				path: 'page-download',
				component: PageDownloadComponent
			},
			{
				path: 'invoice-list',
				component: InvoiceListComponent
			},
			{
				path: 'invoiceCheck',
				component: InvoiceCheckComponent
			},
			{
				path: 'client-management/:id/edit',
				component: ItemEditComponent
			},
			{
				path: 'change-password',
				component: ItemChangePasswordComponent,
				data: {
					authorities: ['ADMIN'],
					pageTitle: 'Đổi mật khẩu'
				}
			},
			{
				path: 'forgot-password',
				component: ItemForgotPasswordComponent,
				data: {
					authorities: ['ADMIN'],
					pageTitle: 'Quên mật khẩu'
				}
			},
		]
	},
	{
		path: '',
		component: LoginLayoutComponent,
		children: [
			{
				path: 'Login',
				 component: LoginComponent
				//loadChildren: './entities/login/login.module#LoginModule'
			}
		]
	},
	{
		path: 'invoice-html/:id/:companyId',
		component: ItemPreviewPopupComponent,
		resolve: {
			'pagingParams': AnnouncementResolvePagingParams
		},
		data: {
			authorities: ['ROLE_ADMIN'],
			pageTitle: 'invoicePdf.title',
		},
		outlet: 'popup'
	},
	{
		path: 'Announcement/Review/:id/:type/:verificationCode',
		component: ItemPreviewAnnouncementPopupComponent,
		resolve: {
			'pagingParams': AnnouncementResolvePagingParams
		},
		data: {
			authorities: ['ROLE_ADMIN'],
			pageTitle: 'Announcement'
		},
		outlet: 'popup'
	},
	{
		path: 'video-tutorial',
		component: VideoTutorialComponent,
	},
	{
        path: 'notification/:messageKey',
        component: DialogNotificationPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'notification'
        },
        outlet: 'notification'
	}, 
	{
        path: 'notification/:messageKey/:messageParams',
        component: DialogNotificationPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'notification'
        },
        outlet: 'notification'
    },
	//{ path: '**', redirectTo: '/invoice-list' }
];

@NgModule({
	imports: [ RouterModule.forRoot(PTLAYOUT_ROUTES, { useHash: true, onSameUrlNavigation: 'reload' },
	)],
	exports: [RouterModule]
})
export class AppRoutingModule { }


